<template>
  <div class="col-6 col-sm-3 col-md-4 col-lg-3 col-xl-3">
    <div class="info-box">
      <span v-bind:class="'info-box-icon elevation-1 bg-'+color"><i v-bind:class="'fas '+icon"></i></span>
          <div class="info-box-content" v-if="status">
            <span class="info-box-text">{{ title }}</span>
            <span class="info-box-number">              
              {{ total }}
              <small>records</small>
            </span>
          </div>
          <div class="info-box-content align-items-center" v-else>
            <div v-bind:class="'spinner-border text-'+color" role="status">
                <span class="sr-only">Loading...</span>
              </div>
          </div>               
    </div>            
  </div>
</template>
<script lang="ts" setup>
 import {  ref,toRefs} from "vue";

    const spiner=ref(false);
    const props = defineProps<{
        title :string,
        total:string|undefined,
        icon: string,
        color: string,
        status:boolean
    }>()

    const {total } = toRefs(props);
    if( typeof total.value === "undefined"){
       spiner.value=false;
    }else{
      spiner.value=true;
    }
</script>
<style scoped>
.info-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f9fa; /* Fondo claro */
  border-radius: 10px; /* Bordes redondeados */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra ligera */
  padding: 15px; /* Espaciado interno */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-box:hover {
  transform: translateY(-5px); /* Efecto de elevación al pasar el ratón */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15); /* Sombra más fuerte */
}

.info-box-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  font-size: 24px;
  color: #fff; /* Icono siempre blanco */
  border-radius: 50%; /* Forma circular */
  margin-right: 15px;
}

.info-box-content {
  flex: 1; /* Ocupa el espacio restante */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-box-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.info-box-number {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
  display: flex;
  align-items: center;
}

.info-box-number small {
  font-size: 14px;
  font-weight: normal;
  margin-left: 5px;
  color: #6c757d;
}

.spinner-border {
  width: 40px;
  height: 40px;
  border-width: 4px;
  margin: auto;
}

.spinner-border.text-primary {
  border-color: #007bff transparent transparent transparent;
}

@media (max-width: 576px) {
  .info-box {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .info-box-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .info-box-content {
    align-items: center;
  }
}
</style>